module.exports = __webpack_public_path__ + "img/saintlucia.0960913d.svg";